/** @format */

import React from "react";
import { Button, Text, Stack, Center } from "@mantine/core";
import { FileText, FolderPlus } from "tabler-icons-react";
import FileCard from "./FileCard";

const FileListDisplay = ({ selectedFiles, onRemoveFile, onSelectFiles, activeChat }) => {
  // Show active chat title if there is one
  const showChatHeader = activeChat && activeChat.title;

  // Empty state when no files are selected
  if (selectedFiles.length === 0) {
    return (
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        {showChatHeader && (
          <div style={{ marginBottom: "16px" }}>
            <Text size="md" weight={600}>
              {activeChat.title}
            </Text>
            <Text size="xs" color="dimmed" mt={4}>
              Files for this chat
            </Text>
          </div>
        )}
        
        <Center style={{ flex: 1, flexDirection: "column", gap: "20px" }}>
          <FolderPlus size={64} color="#9CA3AF" strokeWidth={1.5} />
          <div style={{ textAlign: "center" }}>
            <Text size="lg" weight={500} color="dimmed">
              No files selected
            </Text>
            <Text size="sm" color="dimmed" mt={8}>
              {activeChat 
                ? "This chat has no files associated with it" 
                : "Select documents to start chatting"}
            </Text>
          </div>
          {!activeChat && (
            <Button
              leftIcon={<FileText size={18} />}
              onClick={onSelectFiles}
              size="md"
              style={{
                background: "#46BDE1",
                marginTop: "16px",
              }}
            >
              Select Files
            </Button>
          )}
        </Center>
      </div>
    );
  }

  // Files selected state
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      {/* Header with count and action button */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "16px",
        }}
      >
        <div>
          <Text size="md" weight={600}>
            {showChatHeader ? activeChat.title : `Selected Files (${selectedFiles.length})`}
          </Text>
          {showChatHeader && (
            <Text size="xs" color="dimmed" mt={2}>
              {selectedFiles.length} file{selectedFiles.length > 1 ? "s" : ""}
            </Text>
          )}
        </div>
        {!activeChat && (
          <Button
            variant="subtle"
            size="xs"
            onClick={onSelectFiles}
            leftIcon={<FileText size={14} />}
          >
            Add More
          </Button>
        )}
      </div>

      {/* File List - Scrollable */}
      <Stack
        spacing="sm"
        style={{
          flex: 1,
          overflowY: "auto",
          paddingRight: "4px",
        }}
      >
        {selectedFiles.map((file) => (
          <FileCard 
            key={file.id} 
            file={file} 
            onRemove={activeChat ? null : onRemoveFile}
            readOnly={!!activeChat}
          />
        ))}
      </Stack>

      {activeChat && (
        <Text size="xs" color="dimmed" mt={12} style={{ fontStyle: "italic" }}>
          Close the chat popup to modify files
        </Text>
      )}
    </div>
  );
};

export default FileListDisplay;
